import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { PageLoader } from "@faire/web--source/ui/CircleSpinner";
import React from "react";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { FaireDirectLandingPage } from "@faire/retailer/views/faire-direct/FaireDirectLandingPage";
export var FaireDirectLandingPageRoot = function() {
    var _useFaireDirectBrand = useFaireDirectBrand(), isFaireDirectActiveInLoggedOut = _useFaireDirectBrand.isFaireDirectActiveInLoggedOut, faireDirectBrandToken = _useFaireDirectBrand.faireDirectBrandToken, faireDirectBrand = _useFaireDirectBrand.faireDirectBrand;
    if (!isFaireDirectActiveInLoggedOut) {
        getLocationOrThrow().replace(faireBaseUrl());
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !faireDirectBrand ? /*#__PURE__*/ _jsx(PageLoader, {}) : /*#__PURE__*/ _jsx(CurrentFaireDirectLandingPage, {
            faireDirectBrandToken: faireDirectBrandToken,
            faireDirectBrand: faireDirectBrand
        })
    });
};
var CurrentFaireDirectLandingPage = function(param) {
    var faireDirectBrandToken = param.faireDirectBrandToken, faireDirectBrand = param.faireDirectBrand;
    return /*#__PURE__*/ _jsx(FaireDirectLandingPage, {
        faireDirectBrandToken: faireDirectBrandToken,
        faireDirectBrand: faireDirectBrand
    });
};
